export function parseIndustryBulkValue(value: string): string[] {
    return value
        .trim()
        .split(/\s|\s?[,|]\s?/)
        .filter(Boolean);
}
